$(document).ready(function() {

  //Related products
  let relatedProductsCarousel = $('[data-related-products-carousel]');

  if(relatedProductsCarousel.length > 0) {
    relatedProductsCarousel.owlCarousel({
      items: 4,
      loop: false,
      margin: 40,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      nav: true,
      dots: false
    });
  }

  //Products carousel
  let productsCarousel = $('[data-products-carousel]');

  if(productsCarousel.length > 0) {
    productsCarousel.owlCarousel({
      items: 4,
      loop: false,
      margin: 20,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        750: {
          items: 2,
        },
        990: {
          items: 3,
          margin: 40,
        },
        1300: {
          items: 4,
        }
      }
    });
  }

  //Reviews Carousel
  let reviewsCarousel = $('[data-reviews-carousel]');

  if(reviewsCarousel.length > 0) {
    reviewsCarousel.owlCarousel({
      items: 4,
      loop: true,
      margin: 20,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        750: {
          items: 2,
        },
        990: {
          items: 3,
          margin: 40,
        },
        1300: {
          items: 4,
        }
      }
    });
  }

  //Blog products Carousel
  let blogProductsCarousel = $('[data-blog-product-carousel]');

  if(blogProductsCarousel.length > 0) {
    blogProductsCarousel.owlCarousel({
      items: 1,
      loop: false,
      margin: 20,
      autoplay: false,
      nav: true,
      dots: false,
      mouseDrag: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2,
          nav: false
        },
        750: {
          items: 3,
          nav: false,
        }
      }
    });
  }

  //Blog
  let hiddenPosts = $('.article-card.hidden');

  if(hiddenPosts.length > 0) hiddenPosts.remove();

  let toggleProductFormButton = $('.product-button-toggle');

  if(toggleProductFormButton.length > 0) {
    toggleProductFormButton.on('click', function () {
      let selectedCard = $(this).closest('.product-card--blog');

      selectedCard.toggleClass('show-form');
    })
  }

  //Blog: Load more articles
  let loadMoreToggle = $('.more-articles-button');

  if(loadMoreToggle.length > 0) {
    let currentPage = parseInt(loadMoreToggle.attr('data-current-page'));
    let nextPage = currentPage + 1;
    let posts = $('.article-card--page-'+nextPage);

    if(posts.length === 0) {
      $(this).hide();
    }

    loadMoreToggle.on('click', function () {

      posts = $('.article-card--page-'+nextPage);

      if(posts.length > 0) {
        posts.show();
      } else {
        $(this).hide();
      }

      nextPage++;

      posts = $('.article-card--page-'+nextPage);

      if(posts.length === 0) {
        $(this).hide();
      }
    })
  }

  //Accordion content image (PDP)
  let accordions = $('.product__accordion');

  if(accordions.length > 0) {
    accordions.each(function () {
      let currentAccordionItem = $(this);
      let accordionParagraphs = currentAccordionItem.find('p');

      accordionParagraphs.each(function () {
        let currentParagraph = $(this);
        let currentParagraphIcon = currentParagraph.find('.accordion-paragraph-icon');

        if(currentParagraphIcon.length > 0) {
          currentParagraph.addClass('has-icon')
        }
      })
    });
  }

  //Footer: Mobile menu accordion
  let footerMobileBreakPoint = window.matchMedia("(max-width: 749px)").matches;
  let footerMenuToggle = $('.bsie-footer-menu__title');

  if(footerMobileBreakPoint && footerMenuToggle.length > 0) {
    footerMenuToggle.on('click', function () {
      let currentToggle = $(this);
      let currentMenu = $(this).next();

      if(currentToggle.hasClass('is-opened')) {
        currentToggle.removeClass('is-opened');
        currentMenu.slideUp();
      } else {
        currentToggle.addClass('is-opened');
        currentMenu.slideDown();
      }
    })
  }

  //Account orders popup
  let accountContainer = document.querySelector('#account-container');

  if(accountContainer) {
    let ordersContainer = document.querySelector('#orders-container');
    let viewOrdersButton = document.querySelector('[data-view-orders-button]');
    let viewAccountButton = document.querySelector('[data-view-account-button]');

    viewOrdersButton.addEventListener('click', function () {
      accountContainer.classList.add('is-hidden');
      ordersContainer.classList.remove('is-hidden');
    })

    viewAccountButton.addEventListener('click', function () {
      accountContainer.classList.remove('is-hidden');
      ordersContainer.classList.add('is-hidden');
    })
  }

  //Account address popup
  let openAddressPopupButtons = document.querySelectorAll('[data-open-address-popup-button]');
  let closeAddressPopupButtons = document.querySelectorAll('[data-close-address-popup-button]');
  let newAddressButton = document.querySelector('[data-add-address-button]');
  let newAddressPopups = document.querySelectorAll('[data-address-popup]');
  let newAddressCloseButtons = document.querySelectorAll('[data-add-address-close]');

  openAddressPopupButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      let currentAddressPopupID = button.getAttribute('data-popup');
      let currentAddressPopup = document.querySelector('#'+currentAddressPopupID);

      currentAddressPopup.classList.add('is-visible');
    })
  })

  closeAddressPopupButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      newAddressPopups.forEach(function (popup) {
        popup.classList.remove('is-visible');
      })
    })
  })

  newAddressCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      newAddressPopup.classList.remove('is-visible');
    })
  })
})
